import { FeatureId } from '../../../../../../../Model/Product';

const texts = {
  productDetails: 'Product Details',
  productName: 'Product Name',
  enabledFeatures: 'Enabled Features',
  noFeaturesEnabled: 'No features enabled',
  [FeatureId.NUTRITION_PLAN]: 'Meal Plan',
  [FeatureId.WORKOUT_VIDEO_FEEDBACK]: 'Video Feedback',
  [FeatureId.ASSISTANT_COACH]: 'Assistant Coaching',
  [FeatureId.CHAT]: 'Chat',
  [FeatureId.CHECK_IN_NOTIFICATION]: 'Check-in Feedback',
  [FeatureId.AI_FRIEND]: 'AI Friend',
};

export default texts;
